export class AccordionEvent
{
	public static EXPAND: string = "component:accordion:expand";
	public static COLLAPSE: string = "component:accordion:collapse";

}
